export const en = {
    'error-change-context': 'Could not switch organization',
    'error-com-sync': 'Sync error',
    'error-create': 'Could not create organization.\nPlease select an organization from the list or create a new one',
    'error-fetch-organizations': 'Could not get organization list',
    'error-get-settings': 'Could not get current organization'
};
